import { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { PictureUpload } from "@/components/common/picture-upload/picture-upload";

export const ActionPanel = ({
  button,
  title,
  message,
  disclaimer = <></>,
  image,
  hidePanel = false,
}: {
  button: ReactNode;
  title: string;
  message: string;
  disclaimer?: ReactNode;
  image?: ImageVM;
  /** Sam disclaimer — gdy CTA siedzi już w innym module (np. baner ekspertów). */
  hidePanel?: boolean;
}) => {
  return (
    <div className={"@container mx-auto my-8 max-w-[720px]"}>
      {!hidePanel && (
        <div
          className={cn(
            "mt-4 mb-2 flex flex-col items-center justify-between gap-4 rounded-xl bg-zinc-100 px-8 py-6",
            "@576:gap-12 @576:flex-row @576:items-center",
          )}
        >
          <div className={"flex items-center gap-5"}>
            {image && (
              <div className="hidden aspect-[3/4] h-[96px] shrink-0 md:flex">
                <PictureUpload
                  aspectRatio="3 / 4"
                  image={image}
                  maxHeight={96}
                  className="rounded-md"
                />
              </div>
            )}

            <div>
              <h3
                className={
                  "mb-2 max-w-[400px] text-center text-xl font-bold md:text-left"
                }
              >
                {title}
              </h3>
              <div className={"text-center text-sm text-zinc-600 md:text-left"}>
                {message}
              </div>
            </div>
          </div>

          <div>{button}</div>
        </div>
      )}

      {disclaimer && (
        <div className={`mx-auto my-4 px-4 text-xs text-zinc-600`}>
          {disclaimer}
        </div>
      )}
    </div>
  );
};
